/**
 * @license @tabler/icons-react v3.30.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMailBolt = createReactComponent("outline", "mail-bolt", "IconMailBolt", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

export { IconMailBolt as default };
//# sourceMappingURL=IconMailBolt.mjs.map
